import { checkViewerPermission } from "services/utils/HelperFunction";

// Which "My Request" submodule(s) gate visibility of each actionCentreRegistry
// entry's own pending items -- the same submodule name(s) that type's own
// MyZone > Apply screen already checks (Leave/index.js checks "Leaves",
// Overtime/index.js checks "Myzone Overtime", OffDayDuty/index.js checks
// "Myzone Off Day Duty", AdvanceSalary/index.js checks "Salary Advance").
// Work Adjustment has no single submodule of its own -- its combined screen
// covers Permission/On Duty/Comp Off/Break, each gated on its own submodule
// (WorkAdjustment/index.js's TAB_SUBMODULE_NAME) -- so it's treated as
// accessible if the user has viewer access to any one of the three that have
// a confirmed submodule name (Comp Off doesn't, same reasoning as Sidebar's
// APPLY_CATEGORY_SUBMODULE comment: no confirmed mapping means it can't be
// gated, not that it should be hidden).
const REQUEST_TYPE_SUBMODULES = {
  leave: ["Leaves"],
  overtime: ["Myzone Overtime"],
  offDayDuty: ["Myzone Off Day Duty"],
  workAdjustment: ["Permission", "On Duty", "Break"],
  attendanceCorrection: ["Attendance Correction"],
  advanceSalary: ["Salary Advance"],
};

// A submodule can be provisioned (present in the payload) with viewer:false
// for this user's role -- same gap Sidebar/index.js's isFlyoutCategoryAccessible
// fixed for the "My Requests" flyout itself (a type hidden there by this same
// check must not still surface its count/items on Home: the Pending Requests
// KPI total, the My Requests Summary rows, and the Action Centre strip).
export const isRequestTypeAccessible = (moduleDetails, type) => {
  const screens = REQUEST_TYPE_SUBMODULES[type];
  // No confirmed submodule mapping for this type -- default to showing it
  // rather than guessing a name that could wrongly hide it.
  if (!screens) return true;
  return screens.some((screen) =>
    checkViewerPermission(moduleDetails, "My Request", screen),
  );
};

// Work Adjustment is not one destination any more: My Requests lists
// Permission / On Duty / Comp Off / Break as separate screens, each gated on
// its own "My Request" submodule. Shared by the My Requests Summary card and
// the Action Centre so both split the combined pending list the same way.
// attendance_type strings mirror My_Zone/Apply/work_adjustment/views.py.
export const WORK_ADJUSTMENT_TAB_BY_ATTENDANCE_TYPE = {
  permission: "permission",
  "on duty": "onduty",
  "comp off": "compoff",
  break: "break",
  "cancel break": "break",
};

export const WORK_ADJUSTMENT_TABS = [
  { tab: "permission", label: "Permission", submodule: "Permission" },
  { tab: "onduty", label: "On Duty", submodule: "On Duty" },
  { tab: "compoff", label: "Comp Off", submodule: "Comp Off" },
  { tab: "break", label: "Break", submodule: "Break" },
];

export const workAdjustmentTabOf = (item) =>
  WORK_ADJUSTMENT_TAB_BY_ATTENDANCE_TYPE[
    String(item?.title || "").trim().toLowerCase()
  ];
